import CheckboxStyled from "@/components/CheckboxStyled";
import InputLabelStyled from "@/components/InputLabelStyled";
import Typography from "@mui/material/Typography";

const NetworkLocationFormLegal = ({ onChange }) => {
  const handleCheckboxChanged = (event) => {
    event.target.value = event.target.checked;

    if (onChange && typeof onChange === "function") {
      onChange(event);
    }
  };

  return (
    <>
      <Typography
        variant="h4"
        component="p"
        color="common.black"
        sx={{ mt: 4, mb: 1 }}
      >
        Das Kleingedruckte
      </Typography>
      <InputLabelStyled label="AGB & Datenschutz" />
      <CheckboxStyled
        required
        label="Hiermit bestätige ich, dass ich die AGBs gelesen habe und diese akzeptiere."
        name="consent_agb"
        onChange={handleCheckboxChanged}
      />
      <CheckboxStyled
        required
        label="Hiermit bestätige ich, dass ich den Hinweis zum Datenschutz akzeptiere."
        name="consent_privacy"
        onChange={handleCheckboxChanged}
        marginTop
      />
      <CheckboxStyled
        required
        label="Ich stimme zu, dass meine Daten von popoard NRW, create music e.V. und new heimat sounds gespeichert werden dürfen. Diese Einwilligung ist jederzeit widerrufbar."
        name="creator_consent_datashare"
        onChange={handleCheckboxChanged}
        marginTop
      />
    </>
  );
};

export default NetworkLocationFormLegal;
